import { tenantBranding } from '../services/config';

const Colors = {
    primary: tenantBranding.enabled ? tenantBranding.primaryColor : '#c7755c',
    bg_dark_blur_1: 'rgba(0, 0, 0, 0.5)',
    bg_dark_blur_2: 'rgba(0, 0, 0, 0.7)',
}

export default Colors